// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function fetchHolidayPlans(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.holidayPlans}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addHolidayPlan(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.holidayPlan()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteHolidayPlan(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.holidayPlan(id)}`, {
    method: 'DELETE',
  });
}

export async function updateHolidayPlan({
  id,
  ...data
}: {
  id: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.holidayPlan(id)}`, {
    method: 'PUT',
    data: { id, ...data },
  });
}

export async function fetchWorks(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.works}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateWork({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.work(id)}`, {
    method: 'PUT',
    data: { id, ...data },
  });
}

export async function fetchAlarmConfigs(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.alarmConfigs}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateAlarmEventType({
  id,
  ...data
}: {
  id: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.alarmEventType(id)}`, {
    method: 'PUT',
    data: { id, ...data },
  });
}

export async function resetAlarmEventType({
  functionId,
  eventTypeId,
  ...params
}: {
  functionId: string | number;
  eventTypeId: string | number;
  type: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(
    `${apiProxy}${apiUrl.resetAlarmEventType(functionId, eventTypeId)}`,
    {
      method: 'PUT',
      params,
    },
  );
}

export async function fetchAlarmStrategies({
  functionId,
  eventTypeId,
  ...params
}: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(
    `${apiProxy}${apiUrl.alarmStrategies(functionId, eventTypeId)}`,
    {
      method: 'GET',
      params: adaptPageParams(params),
    },
  );
  return adaptPageResult(res);
}

export async function updateAlarmStrategyPolicy({
  functionId,
  eventTypeId,
  ...data
}: {
  functionId: string | number;
  eventTypeId: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(
    `${apiProxy}${apiUrl.alarmStrategyPolicy(functionId, eventTypeId)}`,
    {
      method: 'POST',
      data,
    },
  );
}

export async function updateAlarmStrategyEnable({
  functionId,
  eventTypeId,
  enable,
  ...data
}: {
  functionId: string | number;
  eventTypeId: string | number;
  enable: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(
    `${apiProxy}${apiUrl.alarmStrategyEnable(functionId, eventTypeId, enable)}`,
    {
      method: 'POST',
      data,
    },
  );
}
